<template>
  <b-container fluid>
    <b-row><h2>Метаболомика</h2></b-row>
    <b-row>
      <b-table :busy="busy"
          :items="items"
          :fields="fields"
               striped
          responsive="sm"
               class="w-100"
      >
        <template #table-busy>
          <div class="text-center text-info my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #thead-top="data">
          <b-tr>
            <b-th>&nbsp;</b-th>
            <b-th>Уровни и назначения</b-th>
            <b-th>&nbsp;</b-th>
            <b-th>&nbsp;</b-th>
          </b-tr>
        </template>
        <template v-slot:head(repletions)="data">
          <b-row>
            <b-col v-for="(val, index) in data.field.labels" :key="index" class="repletion-level-cell">{{val}}</b-col>
          </b-row>
        </template>
        <template v-slot:cell(repletions)="data">
          <b-row>
            <b-col v-for="(val, index) in data.item.repletions" :key="index"  class="repletion-level-cell">{{val.value}}</b-col>
          </b-row>
        </template>
        <template v-slot:cell(buttons)="data">
          <h5 class="buttons">
            <nobr>
              <b-link @click="editParamFactorBandValue(data.item)">
                <b-icon variant="info" icon="pencil" size="lg"></b-icon>
              </b-link>
              &nbsp;
<!--              <b-link @click="deleteRubricatorValue(f, data.item.paramFactorBandId)">-->
<!--                <b-icon variant="info" icon="x-circle" size="lg"></b-icon>-->
<!--              </b-link>-->
            </nobr>
          </h5>
        </template>
<!--        <template v-slot:cell(repletion1)="data" style="width: 7%!important;">-->
<!--          <div style="display: flex;">-->
<!--            <b-form-input v-mask="vMask" @focus="saveCurrentVal(data.item.repletion1)" type="text" placeholder="" v-model="data.item.repletion1" autocomplete="off" style="" class="vitamin-input" ></b-form-input>-->
<!--            <b-icon variant="info" icon="check-circle" style="padding: 0.75rem 0.25rem 0.25rem 0rem;" @click="saveValue" ref="iconSave"></b-icon>-->
<!--            <b-icon icon="x-circle" style="padding: 0.75rem 0.25rem;" @click="declineChange(data.item)"  ref="iconSave"></b-icon>-->
<!--          </div>-->
<!--        </template>-->
      </b-table>
    </b-row>
    <b-modal id="paramVitaminModal" hide-footer size="lg" :title="currentModalTitle">
      <div>
        <b-form @submit.prevent="saveRepletionsValue">
          <b-container fluid>
            <b-row>Значения для уровней</b-row>
            <b-row v-for="(repl, index) in currentValue.repletions" :key="index">
              <b-col style="margin-top: 0.5rem">{{repl.level}}:</b-col>
              <b-col cols="3"><b-form-input v-mask="vMask" type="text" placeholder="0.0" v-model="repl.value" :key="index" autocomplete="off" style="" class="vitamin-input" ></b-form-input></b-col>
              <b-col style="margin-top: 0.5rem">{{ currentValue.measureUnitName}}</b-col>
              <b-col cols="7">&nbsp;</b-col>
            </b-row>
            <b-row class="py-2">
              <b-button variant="info" type="submit" >Сохранить</b-button>
            </b-row>
          </b-container>
        </b-form>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import {host} from "@/constants";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
const valueMask = createNumberMask({
  allowDecimal: true,
  includeThousandsSeparator: false,
  allowNegative: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  prefix: '',
  suffix: ''
})

export default {
  name: "VitaminsView",
  data () {
    return {
      loading: true,
      busy: true,
      error: null,
      vMask: valueMask,
      currentValue: {
        replation1: null
      },
      currentModalTitle: null,
      items: [
      ],
      fields: [
        {
          key: 'vitaminName',
          label: 'Наименование дефицита'
        },
        {
          key: 'repletions',
          label: '',
          labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
        },
        {
          key: 'measureUnitName',
          label: 'Ед. изм'
        },
        {
          key: 'buttons',
          label: ''
        }]
    }
  },
  methods: {
    // saveCurrentVal(currentValue) {
    //   //console.log(ev)
    //   this.currentValue = null
    //   this.currentValue = currentValue
    // },
    // saveValue(ev) {
    //   console.log(JSON.stringify(ev))
    // },
    // declineChange(item) {
    //   console.log("Decline")
    //   //console.log(ev)
    //   console.log(item)
    //   item.repletion1 = this.currentValue
    // },
    async saveRepletionsValue() {
      console.log("success save data " + JSON.stringify(this.currentValue))
      const response = await fetch(host + '/rest/vitamins', {
        method: 'PUT',
        credentials: "include",
        body: JSON.stringify(this.currentValue),
        headers: {'Content-Type': 'application/json; charset=utf-8'}
      })
      const json = await response.json()
      if (json.resultCode == 0) {
        this.$bvModal.hide('paramVitaminModal')
      } else {
        this.$bvToast.toast(json.message, {
          title: `Ошибка`,
          toaster: 'b-toaster-top-center',
          solid: true,
          variant: 'danger',
          noAutoHide: true,
          appendToast: true
        })
      }
    },
    editParamFactorBandValue(item = null) {
      this.currentValue = item
      this.currentModalTitle = item.vitaminName
      // this.currentFactorText = factor.text
      this.$bvModal.show('paramVitaminModal')
    },
    fetchData() {
      fetch(host + '/rest/vitamins', {
        credentials: "include"
      }).then(response => response.json())
          .then(json => {
            console.log(json)
            this.items = json.vitamins
            this.busy = false
          })
    }
  },
  mounted() {
    // this.fields.push(this.baseFields[0])
    // for (let i = 1; i <= this.repletionLevels; i++) {
    //   this.fields.push({key: 'repletion' + i, label: '' + i })
    // }
    // this.fields.push(this.baseFields[1])
    // this.fields.push(this.baseFields[2])

    this.fetchData()
    // fetch(host + '/rest/dicts/paramtype')
    //     .then(response => response.json())
    //     .then(json => {
    //       this.paramTypeOptions = json.options
    //     })
  }
}
</script>

<style scoped>

.vitamin-input {
  border-style: none none solid none;
  line-height: 1;
}
.vitamin-input:focus {
  border-style: none none solid none!important;
  line-height: 1;
}

.repletion-level-cell {
  min-width: 60px!important;
}


</style>